import { Translator } from '../../types/ApiResponseTypes'
import { cdrResponse, isCdrResponse } from '../../types/cdr/CdrResponse'
import { CDR } from '../../types/cdr/CdrType'

class CdrResponseTranslator implements Translator<Array<CDR>> {
  convert(response: any): Array<CDR> {
    if (isCdrResponse(response)) {
      const cdrObject: Array<CDR> = []
      if (Array.isArray(response)) {
        response.forEach((cdr: cdrResponse) => {
          cdrObject.push(this.convertToCdrModel(cdr))
        })
        return cdrObject
      } else {
        return [this.convertToCdrModel(response)]
      }
    }
    return []
  }

  convertToCdrModel(cdr: cdrResponse): CDR {
    return {
      date: cdr.Date,
      country: cdr.Country,
      bundle: cdr.Bundle !== null ? cdr.Bundle : '',
      receiver: cdr.OtherParty,
      data: cdr.Date,
      time: cdr.Time,
      min: cdr.Minutes,
    }
  }
}
export default new CdrResponseTranslator()
